import { useSelector } from 'react-redux';

import Typography from '@mui/material/Typography'

import SaveStatus from "../../UIComponents/SaveStatus";
import RouteInfoObj from "../RouteInfoObj"

import useStyles from "./useStyles";
import mapStateToProps from './mapStateToProps'

const RoutePalette = () => {

    const {
        geoObjRoute ,
        routeSettingsArr = [],
        paletteStatus,
        updateRouteSettingsArr = ()=>{},
        deleteRoute = ()=>{},
    } = useSelector(mapStateToProps)

    const classes = useStyles();

    const updateItem = (index, newItem) => {
        // [...aaa.slice(0,3), 99, ...aaa.slice(3+1)]
        updateRouteSettingsArr([
            ...routeSettingsArr.slice(0, index),
            newItem,
            ...routeSettingsArr.slice(index + 1),
        ])
    }

    if(!paletteStatus)return null

    return (
        <div className={classes.dropdown}>
            <div className={classes.dropdownCont}>
                <Typography variant="h6">Маршруты</Typography>
                <SaveStatus title="Загрузка маршрута" dataObj={geoObjRoute} errShowTime={1000} successShowTime={100}/>
                {routeSettingsArr.map((dataObj, i) => {
                    return (
                        <RouteInfoObj
                            dataObj={dataObj}
                            updateDataObj={(newDataObj) => updateItem(i, newDataObj)}
                            deleteItem={(newDataObj) => deleteRoute(i)}
                            key={i}
                        />
                    )
                })}
            </div>
        </div>
    )
}
export default RoutePalette